import { LocationState, Location } from './types';

export function mapCenter(state: LocationState): Location {
  const item = state.locations.filter(l => l.id === state.mapCenterId)[0];

  if (item == null) {
    return {
      id: 1,
      parkCode: 'x',
      name: "Map Center",
      lat: 37.6,
      lng: -95.665
    };
  }

  return item;
}

export function allLocations(state: LocationState) {
  return state.locations.filter(l => l.id !== state.mapCenterId)
}

export function onlyWithLocations(places: any) {
  const list: Location[] = places.filter((item: any) => {
    return (item.lat && item.lng)
  });
  return list;
}

export function addLocations(places: any, list: any) {
  const newList = list.map((item: any) => {
    return places[item];
  });
  return newList;
}

export function formatUsersList(visited: any, favorites: any, bucket: any) {
  const places = {};
  visited.forEach((item: string) => {
    places[item] = {
      parkCode: item,
      tags: ['visited'],
    };
  });
  favorites.forEach((item: string) => {
    if (places[item]) {
      places[item].tags.push('favorites')
    } else {
      places[item] = {
        parkCode: item,
        tags: ['favorites'],
      };
    }
  });
  bucket.forEach((item: string) => {
    if (places[item]) {
      places[item].tags.push('bucket')
    } else {
      places[item] = {
        parkCode: item,
        tags: ['bucket'],
      };
    }
  });
  return places;
}
